/* Skeleton-loader fallback. Mirrors the pattern in sections/pg_featured_blog_article.liquid:
   tags an image wrapper with .pg-skel until its <img> fires `load`, then adds .pg-skel-loaded.
   Works for both lazysizes-managed images and native loading="lazy" images. */
(function () {
  if (typeof document === 'undefined') return;

  var WRAPPER_SELECTORS = ['.img-wrap', '.media-wrap'];

  function findWrapper(img) {
    var el = img.parentElement;
    while (el && el !== document.body) {
      for (var i = 0; i < WRAPPER_SELECTORS.length; i++) {
        if (el.matches(WRAPPER_SELECTORS[i])) return el;
      }
      el = el.parentElement;
    }
    return img.parentElement;
  }

  function markWrapper(img) {
    // Skip images that are part of an eager-loading hero (above-the-fold).
    // These are priority-loaded for LCP and don't benefit from a skeleton.
    if (img.closest && img.closest('hero-banner, .hero-banner-container')) return;

    var wrap = findWrapper(img);
    if (!wrap) return;
    if (img.complete && img.naturalWidth > 0) return; // already loaded, no skeleton needed

    // Ensure wrapper can host the absolutely-positioned ::before
    var cs = window.getComputedStyle ? window.getComputedStyle(wrap) : null;
    if (cs && cs.position === 'static') wrap.style.position = 'relative';

    wrap.classList.add('pg-skel');
    function done() {
      wrap.classList.add('pg-skel-loaded');
      img.removeEventListener('load', done);
      img.removeEventListener('error', done);
    }
    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
  }

  function scan(root) {
    var r = root || document;
    var imgs = r.querySelectorAll(
      'img.lazyload, img.lazyloading, img[loading="lazy"]:not([fetchpriority="high"])'
    );
    for (var i = 0; i < imgs.length; i++) markWrapper(imgs[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  // Re-scan when lazysizes inserts new lazyloaded markup or sections re-render
  document.addEventListener('lazybeforeunveil', function (e) {
    if (e.target && e.target.tagName === 'IMG') markWrapper(e.target);
  });
  document.addEventListener('shopify:section:load', function () { scan(); });
})();
